/**
 * Shared text/unit normalization for matching and unit codes (0163).
 */
/** Drop Unicode combining marks (U+0300–U+036F) left by `normalize('NFD')`. */
export function stripDiacritics(s) {
    let out = '';
    for (const ch of s) {
        const code = ch.codePointAt(0) ?? 0;
        if (code >= 0x0300 && code <= 0x036f)
            continue;
        out += ch;
    }
    return out;
}
/**
 * Compare commercial / base / packaging unit codes without accent or punctuation.
 *
 * - `PÇ` / `pç.` / `PC` → `PC`
 * - `M²` / `M2` / `M 2` → `M2`
 *
 * Does **not** expand vocabulary synonyms (`PCS`, `UNID`) — those belong in
 * partner `unitMappings`, not a silent rule here.
 */
export function normalizeUnitCode(unit) {
    const raw = (unit ?? '').trim();
    if (!raw)
        return '';
    // NFKC folds superscripts (²→2); NFD + stripDiacritics folds accents (Ç→C).
    const folded = stripDiacritics(raw.toUpperCase().normalize('NFKC').normalize('NFD'));
    return folded.replace(/[^A-Z0-9]+/g, '');
}
//# sourceMappingURL=normalizeText.js.map